import type React from 'react'
import type { LabelHTMLAttributes } from 'react'

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
	children: React.ReactNode
	htmlFor?: string
}

export const Label = ({ children, htmlFor }: LabelProps) => (
	<label
		className='block truncate text-start font-medium text-neutral-700 text-sm'
		htmlFor={htmlFor}
	>
		{children}
	</label>
)

Label.displayName = 'Label'
